import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'questFields', 'submitButton'];

  connect() {
    this.updateButtonAttributes();
  }

  toggleFields() {
    const isChecked = this.checkboxTarget.checked;

    if (isChecked) {
      this.questFieldsTarget.classList.remove('hidden');
      this.questFieldsTarget.classList.add('flex', 'flex-col', 'gap-20');
    } else {
      this.questFieldsTarget.classList.add('hidden');
      this.questFieldsTarget.classList.remove('flex', 'flex-col', 'gap-20');
      this.clearQuestFields();
    }

    this.updateButtonAttributes();
  }

  clearQuestFields() {
    const inputs = this.questFieldsTarget.querySelectorAll('input[name*="notes"], textarea[name*="notes"]');
    inputs.forEach(input => {
      input.value = '';
    });
  }

  updateButtonAttributes() {
    if (!this.hasSubmitButtonTarget) return;

    const isChecked = this.checkboxTarget.checked;

    if (isChecked) {
      this.submitButtonTarget.setAttribute('name', 'send_to_quest');
      this.submitButtonTarget.setAttribute('value', '1');
    } else {
      this.submitButtonTarget.removeAttribute('name');
      this.submitButtonTarget.removeAttribute('value');
    }
  }
}
